import { isEmpty } from "lodash";
import { Base } from "../base";

export enum NFTRewardType {
  "TEXT" = "text",
  "URL" = "url",
}

export enum NFTRewardError {}

export interface NFTRewardParam extends Partial<NFTReward> {}

export class NFTReward extends Base {
  type: NFTRewardType;
  content: string;

  constructor(params: NFTRewardParam) {
    super(params);
    this.type = params.type || NFTRewardType.TEXT;
    this.content = params.content || "";
  }
}

export interface NFTRewardCustomization {}

export interface NFTEventTierRewardConfigParam
  extends Partial<NFTEventTierRewardConfig> {
  rewardId: string;
}

export class NFTEventTierRewardConfig {
  rewardId: string;
  customization?: NFTRewardCustomization; // UI customizations etc.

  constructor(params: NFTEventTierRewardConfigParam) {
    this.rewardId = params.rewardId;
    if (params.customization && !isEmpty(params.customization))
      this.customization = params.customization;
  }
}
